export function encodeQueryParams(params: Record<string, string>): string {
  return Object.entries(params)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join('&');
}

export function buildRelativePath(
  path: string,
  params: Record<string, string>
): URL {
  const url = new URL(path, window.location.origin);

  url.search = encodeQueryParams(params);

  return url;
}
